import { starRatingWidgetParser } from "@redotech/redo-model/review/star-rating-widget-schema";
import { z } from "zod";

export const getStarRatingWidgetByTeam = {
  input: z.object({ teamId: z.string() }),
  output: z.union([starRatingWidgetParser, z.null()]),
};
